'use client';

import { type HTMLAttributes, forwardRef } from 'react';
import { cn } from '@medizzconnect/shared';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  /** max-w-content = 1200px, max-w-narrow = 800px, max-w-wide = 1400px */
  maxWidth?: 'narrow' | 'content' | 'wide';
}

const maxWidthClasses = {
  narrow: 'max-w-[800px]',
  content: 'max-w-content',
  wide: 'max-w-[1400px]',
} as const;

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, maxWidth = 'content', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'mx-auto w-full px-4 sm:px-6 lg:px-8',
        maxWidthClasses[maxWidth],
        className,
      )}
      {...props}
    />
  ),
);

Container.displayName = 'Container';

export { Container };
